import * as constants from './constants';

export const startLoader = () => ({ type: constants.START_LOADER });
export const stopLoader = () => ({ type: constants.STOP_LOADER });
